import React, { useState, useEffect } from "react";
import "./css/TopNav.css";

const TopNav = ({ currentPage, onNavigate, onNavVisibilityChange }) => {
  const [showNav, setShowNav] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      let newShowNav;
      if (currentScrollY <= 50) {
        newShowNav = true;
      } else if (currentScrollY > lastScrollY) {
        newShowNav = false;
        setMobileMenuOpen(false);
      } else {
        newShowNav = true;
      }
      setShowNav(newShowNav);
      if (onNavVisibilityChange) {
        onNavVisibilityChange(newShowNav);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY, onNavVisibilityChange]);

  const handleClick = (page) => {
    onNavigate(page);
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`topnav ${showNav ? "visible" : "hidden"}`}>
      <div className="topnav-left">
        <a
          href="/"
          className="home-link"
          onClick={(e) => {
            e.preventDefault();
            handleClick("home");
          }}
        >
          <img src="/vyral.png" alt="Vyral Logo" className="topnav-logo" />
          <span className="topnav-brand">Vyral Media Group</span>
        </a>
      </div>

      <button
        className="mobile-menu-button"
        aria-label="Toggle menu"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      >
        ☰
      </button>

      <ul className={`topnav-menu ${mobileMenuOpen ? "open" : ""}`}>
        <li>
          <a
            href="/"
            className={`nav-link ${currentPage === "home" ? "active" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              handleClick("home");
            }}
          >
            Home
          </a>
        </li>
        <li>
          <a
            href="/products"
            className={`nav-link ${currentPage === "products" ? "active" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              handleClick("products");
            }}
          >
            Products
          </a>
        </li>
        <li>
          <a
            href="/divisions"
            className={`nav-link ${currentPage === "divisions" || currentPage === "divisionShowcase" ? "active" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              handleClick("divisions");
            }}
          >
            Divisions
          </a>
        </li>
        <li>
          <a
            href="/about"
            className={`nav-link ${currentPage === "about" ? "active" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              handleClick("about");
            }}
          >
            About
          </a>
        </li>
        <li>
          <a
            href="/employment"
            className={`nav-link ${currentPage === "employment" ? "active" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              handleClick("employment");
            }}
          >
            Careers
          </a>
        </li>
        <li>
          <a
            href="/contact"
            className={`nav-link ${currentPage === "contact" ? "active" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              handleClick("contact");
            }}
          >
            Contact
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default TopNav;